export default __webpack_public_path__ + "static/media/twitter.3fdb1778.svg";